/* Afroyla DD DEAL — ⚡ Lightning Deals box: one product per 30-SECOND slot (anh 09-25: 60 s → 30 s).
 * Schedule JSON = ops' 840-deal list (built as a 1-min grid). Slot = floor((now − START) / 30 s); deal = deals[slot % 840],
 * so the list plays through in 7 h and repeats once (same order/spacing, each product shown twice as often).
 * Swaps in place every 30 s (no reload). Live stock + price come from /products/<handle>.js; the JSON is the fallback.
 * Sold-out keeps the same minute (never jumps to another product). Needs window.AFDD (afroyla-dd-deal-core.js). */
(function () {
  var A = window.AFDD;
  if (!A) return;
  var box = A.root.querySelector('[data-add-ld]');
  var nextWrap = A.root.querySelector('[data-add-next]');
  var nextRow = A.root.querySelector('[data-add-next-row]');
  var deals = [];
  var shownKey = null; // 'pre' | 'ended' | deal index
  var cur = null;      // { deal, idx, sel, vars: { id: {price, compare, available} } }

  fetch(A.root.dataset.schedule, { credentials: 'omit' })
    .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
    .then(function (j) { deals = j.deals || []; tick(); setInterval(tick, 250); })
    .catch(function () { box.innerHTML = '<p class="add-ld__msg">Lightning Deals are loading slowly. Please refresh the page.</p>'; });

  var SLOT = 30000; // ms per Lightning slot
  function dealStart(i) { return A.START + i * SLOT; }
  function indexNow() { return Math.floor((A.now() - A.START) / SLOT); }
  function dealAt(i) { return deals.length ? deals[i % deals.length] : null; }

  // live countdown label for an upcoming deal: "in 22s" under a minute, else "in 1:22" (hours before open → h:mm:ss)
  function inLabel(ms) { var sec = Math.max(0, Math.ceil(ms / 1000)); return 'in ' + (sec < 60 ? sec + 's' : sec < 3600 ? A.mmss(ms) : A.hms(ms)); }

  function tick() {
    var p = A.phase();
    var key = p === 'live' ? indexNow() : p;
    if (key !== shownKey) {
      shownKey = key;
      if (p === 'pre') renderPre();
      else if (p === 'ended') renderEnded();
      else if (dealAt(key)) renderDeal(key);
      else renderEnded();
    }
    updateTimer(p);
  }

  function renderPre() {
    cur = null;
    box.innerHTML = '<div class="add-ld__pre"><p class="add-ld__pre-k">First deal drops at ' + A.esc(A.whenLabel(A.START)) + '</p>' +
      '<p class="add-ld__pre-t" data-ld-left>' + A.hms(A.START - A.now()) + '</p>' +
      '<p class="add-ld__pre-s">Then a new deal every 30 seconds, all day. Keep this page open.</p></div>';
    renderNext(0);
  }

  function renderEnded() {
    cur = null;
    box.innerHTML = '<p class="add-ld__msg">Lightning Deals have ended. Thank you for shopping with us!</p>';
    nextWrap.hidden = true;
  }

  function renderDeal(i) {
    var d = dealAt(i);
    var vars = {};
    d.vs.forEach(function (v) { vars[v[0]] = { name: v[1], price: v[2], compare: v[3], available: true }; });
    cur = { deal: d, idx: i, sel: d.v, vars: vars };
    var url = '/products/' + d.h;
    box.innerHTML =
      '<div class="add-ld__card">' +
        '<a class="add-ld__media" href="' + url + '" data-hc-el="collection-card-image">' +
          '<img src="' + A.img(d.img, 900) + '" alt="' + A.esc(d.t) + '" width="900" height="900">' +
          '<span class="add-badge" data-ld-badge></span><span class="add-soldout" data-ld-soldout hidden>Sold out</span></a>' +
        '<div class="add-ld__info">' +
          '<p class="add-ld__timer">Deal ends in <b data-ld-left></b></p>' +
          '<div class="add-ld__bar"><i data-ld-bar></i></div>' +
          '<h3 class="add-ld__title"><a href="' + url + '" data-hc-el="collection-card">' + A.esc(d.t) + '</a></h3>' +
          '<p class="add-price"><span class="add-price__now" data-ld-now></span> <s class="add-price__was" data-ld-was></s></p>' +
          (d.vs.length > 1 ? '<div class="add-vars" role="radiogroup" aria-label="Leather" data-ld-vars></div>' : '') +
          '<button type="button" class="add-btn add-btn--big" data-ld-add data-hc-el="x-dd-lightning-add">Add to cart</button>' +
          '<p class="add-ld__note">Add it the moment you see it. Your price holds in your cart until ' + A.esc(A.whenLabel(A.END - 60000)) + ', but stock doesn\'t: items can sell out before you check out.</p>' +
        '</div>' +
      '</div>';
    paint();
    box.querySelector('[data-ld-add]').addEventListener('click', function () {
      var v = cur && cur.vars[cur.sel];
      if (v && v.available) A.runAdd(this, cur.sel, A.img(cur.deal.img, 300));
    });
    renderNext(i + 1);
    // live stock + price (JSON stays as fallback if this fails)
    fetch('/products/' + d.h + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (!p || !cur || cur.idx !== i) return;
        p.variants.forEach(function (v) {
          var o = cur.vars[v.id];
          if (!o) return;
          o.available = v.available;
          o.price = v.price / 100;
          if (v.compare_at_price) o.compare = v.compare_at_price / 100;
        });
        // featured variant sold out → preselect another available one
        if (!cur.vars[cur.sel].available) {
          var alt = Object.keys(cur.vars).filter(function (id) { return cur.vars[id].available; })[0];
          if (alt) cur.sel = Number(alt);
        }
        paint();
      })
      .catch(function () {});
  }

  // Price / badge / variant pills / button for the current selection
  function paint() {
    var v = cur.vars[cur.sel];
    var anyAvail = Object.keys(cur.vars).some(function (id) { return cur.vars[id].available; });
    box.querySelector('[data-ld-now]').textContent = A.money(v.price);
    box.querySelector('[data-ld-was]').textContent = v.compare > v.price ? A.money(v.compare) : '';
    var off = A.pct(v.price, v.compare);
    var badge = box.querySelector('[data-ld-badge]');
    badge.textContent = off ? '−' + off + '%' : '';
    badge.hidden = !off;
    box.querySelector('[data-ld-soldout]').hidden = anyAvail;
    var btn = box.querySelector('[data-ld-add]');
    btn.disabled = !v.available;
    btn.textContent = v.available ? 'Add to cart' : 'Sold out';
    var wrap = box.querySelector('[data-ld-vars]');
    if (!wrap) return;
    var labels = A.variantLabels(cur.deal.vs.map(function (x) { return x[1]; }));
    wrap.innerHTML = cur.deal.vs.map(function (x, k) {
      var o = cur.vars[x[0]];
      return '<button type="button" role="radio" class="add-var' + (x[0] === cur.sel ? ' is-on' : '') + '" aria-checked="' + (x[0] === cur.sel) + '"' +
        (o.available ? '' : ' disabled') + ' data-v="' + x[0] + '" data-hc-el="variant-picker">' +
        A.esc(labels[k]) + ' <b>' + A.money(o.price) + '</b></button>';
    }).join('');
    wrap.querySelectorAll('[data-v]').forEach(function (b) {
      b.addEventListener('click', function () { cur.sel = Number(b.dataset.v); paint(); });
    });
  }

  // Teasers of the next deals: clear photo + % OFF + drop time, never name or price
  // (anh 09-25: unblurred + show % OFF so shoppers wait for it)
  function nextPct(d) {
    var v = d.vs.filter(function (x) { return x[0] === d.v; })[0] || d.vs[0];
    return A.pct(v[2], v[3]);
  }
  function renderNext(from) {
    var items = []; for (var k = 0; k < 4 && dealStart(from + k) < A.END && dealAt(from + k); k++) items.push(dealAt(from + k));
    nextWrap.hidden = !items.length;
    nextRow.innerHTML = items.map(function (d, k) {
      var off = nextPct(d);
      return '<div class="add-next__item"><div class="add-next__img"><img src="' + A.img(d.img, 300) + '" alt="Upcoming deal" loading="lazy" width="300" height="400">' +
        (off ? '<span class="add-next__off">−' + off + '%</span>' : '') + '</div>' +
        // live "in Xs" countdown per teaser (ticks in updateTimer); no time-zone math for shoppers outside ET
        '<span data-next-at="' + (from + k) + '">' + inLabel(dealStart(from + k) - A.now()) + '</span></div>';
    }).join('');
  }

  function updateTimer(p) {
    nextRow.querySelectorAll('[data-next-at]').forEach(function (el) { el.textContent = inLabel(dealStart(+el.dataset.nextAt) - A.now()); });
    var left = box.querySelector('[data-ld-left]');
    if (!left) return;
    if (p === 'pre') { left.textContent = A.hms(A.START - A.now()); return; }
    if (!cur) return;
    var remain = dealStart(cur.idx + 1) - A.now();
    left.textContent = A.mmss(remain);
    var bar = box.querySelector('[data-ld-bar]');
    if (bar) bar.style.width = Math.max(0, Math.min(100, remain / SLOT * 100)) + '%';
  }
})();
